import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M12 13.9091 2 8.4545 12 3l10 5.4545zm0 3.6364-9.4773-5.1591 1.9091-1.0455L12 15.4773l7.5682-4.1364 1.9091 1.0455zm0 3.6363-9.4773-5.1591 1.9091-1.0454L12 19.1136l7.5682-4.1363 1.9091 1.0454zm0-9.3409 6.2045-3.3863L12 5.0681 5.7955 8.4545z"
  />,
  'ConfigurationManager',
);
